var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 51,
    viewBox: "0 0 160 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "61.024%",
    x2: "26.115%",
    y1: "4.84%",
    y2: "71.968%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".7%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.2%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "107.724%",
    x2: "-130.67%",
    y1: "49.424%",
    y2: "49.424%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.9%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.5%",
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "86.389%",
    x2: "-49.886%",
    y1: "30.829%",
    y2: "136.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "-18.581%",
    x2: "42.275%",
    y1: "-11.683%",
    y2: "35.066%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.9%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.6%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.1%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M154.074 50.366H5.926C2.607 50.366 0 47.618 0 44.12V6.643C0 3.145 2.607.397 5.926.397h148.148c3.319 0 5.926 2.748 5.926 6.246V44.12c0 3.498-2.607 6.246-5.926 6.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    fillRule: "nonzero",
    d: "M154.074 1.396c2.726 0 4.978 2.373 4.978 5.247V44.12c0 2.874-2.252 5.247-4.978 5.247H5.926C3.2 49.367.948 46.994.948 44.12V6.643c0-2.874 2.252-5.247 4.978-5.247h148.148zm0-1H5.926C2.607.397 0 3.27 0 6.644V44.12c0 3.498 2.607 6.246 5.926 6.246h148.148c3.319 0 5.926-2.748 5.926-6.246V6.643c0-3.373-2.607-6.246-5.926-6.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M48.425 13.805v-1.333h3.956v.667c0 1.103-.295 1.988-.923 2.616-.792.792-1.713 1.174-2.866 1.174s-2.075-.382-2.867-1.174c-.792-.792-1.173-1.713-1.173-2.866s.381-2.074 1.173-2.866c.792-.792 1.714-1.174 2.867-1.174.526 0 1.051.132 1.573.393.586.293.94.559 1.189.931l.076.114-.853.853-.117-.146c-.455-.569-1.021-.811-1.868-.811-.772 0-1.437.272-1.869.811l-.012.015-.014.011c-.55.44-.812 1.11-.812 1.994 0 .883.263 1.554.812 1.993.717.574 1.272.838 1.895.838.837 0 1.417-.237 2.005-.825.334-.334.532-.742.57-1.215h-2.742zm9.703 1.666v1.333h-4.706v-7.83h4.706v1.209h-3.373v2.04h3.123v1.208h-3.123v2.04h3.373zm4.122 1.333h-1.333v-6.621h-2.123V8.974h5.58v1.209H62.25v6.62zm5.413-7.83h1.333v7.83h-1.333v-7.83zm5.414 7.83H71.91v-6.621h-2.124V8.974h5.456v1.209h-2.124v6.454h-.042v.167zm11.986-1.049c-.792.792-1.714 1.174-2.867 1.174s-2.074-.382-2.866-1.174c-.792-.792-1.173-1.713-1.173-2.866s.381-2.074 1.173-2.866c.792-.792 1.713-1.174 2.866-1.174s2.075.382 2.867 1.174c.792.792 1.173 1.713 1.173 2.866s-.381 2.074-1.173 2.866zm-4.747-.86c.5.5 1.215.825 1.88.825.772 0 1.437-.272 1.869-.811l.012-.014a2.844 2.844 0 0 0 .826-2.006c0-.883-.263-1.554-.812-1.993l-.014-.013c-.5-.5-1.215-.825-1.88-.825-.772 0-1.437.272-1.87.811l-.011.014a2.844 2.844 0 0 0-.826 2.006c0 .883.262 1.554.812 1.993l.014.013zm8.169 1.909h-1.209v-7.83h1.385l3.363 5.45v-5.45h1.333v7.83h-1.258l-3.614-5.713v5.713zM78.074 27.63c-2.998 0-5.372 2.249-5.372 5.372a5.332 5.332 0 0 0 5.372 5.372c2.998 0 5.372-2.249 5.372-5.372 0-3.248-2.374-5.372-5.372-5.372zm0 8.495c-1.624 0-2.998-1.374-2.998-3.248s1.374-3.248 2.998-3.248 2.998 1.25 2.998 3.248c0 1.874-1.374 3.248-2.998 3.248zM66.456 27.63c-2.998 0-5.372 2.249-5.372 5.372a5.332 5.332 0 0 0 5.372 5.372c2.998 0 5.372-2.249 5.372-5.372 0-3.248-2.374-5.372-5.372-5.372zm0 8.495c-1.624 0-2.998-1.374-2.998-3.248s1.374-3.248 2.998-3.248 2.998 1.25 2.998 3.248c0 1.874-1.374 3.248-2.998 3.248zm-13.867-6.87v2.248h5.372c-.125 1.25-.625 2.248-1.25 2.873-.749.75-1.998 1.624-4.122 1.624-3.373 0-5.871-2.623-5.871-5.996s2.623-5.997 5.871-5.997c1.75 0 3.123.75 4.123 1.624l1.624-1.624c-1.374-1.249-3.123-2.248-5.622-2.248-4.497 0-8.37 3.747-8.37 8.245 0 4.497 3.873 8.245 8.37 8.245 2.499 0 4.248-.75 5.747-2.374 1.499-1.499 1.998-3.623 1.998-5.247 0-.5 0-1-.124-1.374h-7.746zm56.716 1.748c-.5-1.25-1.749-3.373-4.497-3.373-2.749 0-4.997 2.124-4.997 5.372 0 2.998 2.248 5.372 5.247 5.372 2.373 0 3.872-1.5 4.372-2.374l-1.749-1.25c-.625.875-1.374 1.5-2.623 1.5-1.25 0-2-.5-2.624-1.624l7.121-2.998-.25-.625zm-7.246 1.75c0-2 1.624-3.124 2.749-3.124.874 0 1.749.5 1.999 1.124l-4.748 2zm-5.871 5.121h2.374V22.258h-2.374v15.616zm-3.748-9.12c-.624-.624-1.624-1.249-2.873-1.249-2.623 0-5.122 2.374-5.122 5.372 0 2.998 2.374 5.247 5.122 5.247 1.25 0 2.249-.625 2.748-1.25h.125v.75c0 1.999-1.124 3.123-2.873 3.123-1.374 0-2.374-1-2.623-1.874l-2 .875c.625 1.374 2.124 3.123 4.748 3.123 2.748 0 4.997-1.624 4.997-5.497V27.88H92.44v.874zm-2.748 7.371c-1.624 0-2.998-1.374-2.998-3.248s1.374-3.248 2.998-3.248 2.873 1.374 2.873 3.248-1.25 3.248-2.873 3.248zm30.482-13.867h-5.622v15.616h2.374v-5.871h3.248c2.623 0 5.121-1.874 5.121-4.873 0-2.998-2.498-4.872-5.121-4.872zm.124 7.496h-3.372v-5.372h3.372c1.75 0 2.749 1.5 2.749 2.624-.125 1.374-1.124 2.748-2.749 2.748zm14.367-2.249c-1.75 0-3.498.75-4.123 2.374l2.124.874c.5-.874 1.25-1.124 2.124-1.124 1.249 0 2.373.75 2.498 1.999v.125c-.374-.25-1.374-.625-2.373-.625-2.249 0-4.498 1.25-4.498 3.498 0 2.124 1.874 3.498 3.873 3.498 1.624 0 2.374-.75 2.998-1.5h.125v1.25h2.249v-5.996c-.25-2.749-2.374-4.373-4.997-4.373zm-.25 8.62c-.75 0-1.874-.375-1.874-1.374 0-1.25 1.374-1.624 2.499-1.624.999 0 1.499.25 2.123.5-.25 1.499-1.499 2.498-2.748 2.498zm13.117-8.245l-2.623 6.746h-.125l-2.749-6.746h-2.498l4.122 9.494-2.373 5.247h2.373l6.372-14.741h-2.499zm-20.987 9.994h2.373V22.258h-2.373v15.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M.5.625C.125.999 0 1.624 0 2.374v27.608c0 .75.25 1.374.625 1.749l.125.125 15.49-15.49v-.25L.5.624z",
    transform: "translate(9.492 9.141)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M21.237 21.612l-5.122-5.122v-.375l5.122-5.122.125.125 6.121 3.498c1.75 1 1.75 2.624 0 3.623l-6.246 3.373z",
    transform: "translate(9.492 9.141)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M21.362 21.487l-5.247-5.247L.5 31.856c.624.624 1.499.624 2.623.125l18.24-10.494",
    transform: "translate(9.492 9.141)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M21.362 10.993L3.123.625C2 0 1.124.125.5.75l15.615 15.49 5.247-5.247z",
    transform: "translate(9.492 9.141)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.73 30.503L12.616 40.747c-1 .625-1.874.5-2.499 0l-.125.125.125.125c.625.5 1.5.625 2.499 0L30.73 30.503z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M9.992 40.747c-.375-.375-.5-1-.5-1.749v.125c0 .75.25 1.374.625 1.75v-.126h-.125zm26.984-13.741l-6.246 3.497.125.125 6.121-3.498c.874-.5 1.25-1.124 1.25-1.749 0 .625-.5 1.125-1.25 1.625z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.616 9.89l24.36 13.867c.75.5 1.25 1 1.25 1.624 0-.624-.376-1.249-1.25-1.748L12.616 9.766c-1.75-1-3.124-.25-3.124 1.749v.125c0-1.874 1.375-2.749 3.124-1.75z",
    opacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.e8b4e45cceb67acd419f9068ab932266.svg";
export { ForwardRef as ReactComponent };